<ml-mdm-apple-device-power-ui [class]="'btn btn-outline-primary border-0'"
                              [apple]="appleDeviceInformation$ | async">
</ml-mdm-apple-device-power-ui>